import "./StoreInfoCard.scss";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams, Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import IconButton from "@mui/material/IconButton";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import noImg from "../../../js/assets/images/no-image.svg";
import { Button, useMediaQuery } from "@material-ui/core";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Edit } from "@mui/icons-material";
import { ReactComponent as InfoIcon } from "../../../js/assets/images/info.svg";
import { ReactComponent as MeetOrigin } from "../../../js/assets/images/meet-origin.svg";
import { Skeleton } from "@material-ui/lab";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

const StoreInfoCard = () => {
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const [branchName, setBranchName] = useState("");
  const min452 = useMediaQuery("(min-width:452px)");
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [table, setTable] = useState("");
  const [pickup, setPickup] = useState("");

  const handleSourceOfMeet = () => {
    appDispatch({
      type: "setSourceOfMeetBanner",
      sourceOfMeetBannerImage: true,
    });
  };

  useEffect(() => {
    const getBranchTable = () => {
      if (Boolean(appState.qrBranch)) {
        let flag = true;
        if (appState.storeInfo.branch != null) {
          let branchData = appState.storeInfo.branch;
          if (branchData.id == appState.qrBranch) {
            setBranchName(branchData.name);
            appDispatch({
              type: "setBranch",
              branch: branchData.name,
            });
          }
        }
        if (appState.storeInfo.pickup != null) {
          let pickupData = appState.storeInfo.pickup;
          if (pickupData.id == appState.qrPickup) {
            setPickup(pickupData.name);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } else if (appState.storeInfo.table != null) {
          let tableData = appState.storeInfo.table;
          if (tableData.id == appState.qrTable) {
            setTable(tableData.name);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      }
    };
    if (appState.qrBranch) {
      getBranchTable();
    }
  }, [appState.qrBranch, appState.storeInfo.branch]);

  return (
    <>
      <div id="mySidenav" className={`StoreInfoCard px-0  ${   appState?.langValue === "ar" ? "StoreInfoCardMainArabic" : " " }`}>
        <div className="BannerParent">
          <div className="px-2 DescriptionSection  w-100">
            <div className=" tableShow  mb-3 mt-3 py-3">
              <div className={`d-flex align-items-start justify-content-between flex-wrap`} style={{   textAlign: appState.langValue === "ar" ? "right" : "left", }} >
                <div className={`d-flex align-items-center flex-wrap`}>
                  <div className={`logo-div`}>
                    <img src={appState.storeInfo.logo  ? `${appState.storeInfo.logo}`  : { noImg } } className="img-fluid" alt="" />
                 </div>
                  <h3 className="familyPoppins700 storeName mx-2 ">
                    {get_lang( appState.storeInfo.businessName, appState.langValue )}
                    {appState.qrBranch != null && (
                      <p className={` text-secondary store-branch-name m-0 ${ appState.langValue === "ar"? "text-right": "text-left" }`} >
                        {get_lang(branchName, appState.langValue)}{" "}
                      </p>
                    )}
                  </h3>
                </div>

                <span className={`${appState.sourceOfMeetBanner && !min452  ? `d-flex flex-column`: `` } align-items-start`}>
                  {appState.sourceOfMeetBanner && (
                    <Link to="/" className={`p-0 m-0 ${min452 ? "mx-1" : "mb-1"} `} >
                      <Button variant="text" className={`infoBtn-store-info px-2  ${   appState.langValue === "ar"     ? "text-right"     : "text-left" }  `} 
                              startIcon={<MeetOrigin />} onClick={() => handleSourceOfMeet()}>
                        <span className={appState.langValue === "ar" ? "mr-2" : ""} >
                          {t("side-bar.source-of-meet")}{" "}
                        </span>
                      </Button>
                    </Link>
                  )}

                  <Link to="/contact" className={`p-0 m-0 ${   appState.storeInfo.disabledBtns ? `pe-none` : `` }   `} >
                    <Button variant="text" className={`infoBtn-store-info px-2  ${   appState.langValue === "ar" ? "text-right" : "text-left" }  `} startIcon={<InfoIcon />} >
                      <span className={appState.langValue === "ar" ? "mr-2" : ""} >
                        {t("Info")}
                      </span>
                    </Button>
                  </Link>
                </span>
              </div>
              <div className="d-flex aling-items-center">
                {appState.acceptedPayments.length > 0 && (
                  <div>
                    <p className="m-0 payment-heading d-flex my-2">
                      {t("Service.payment")}{" "}
                    </p>
                    <div className="row m-0 ">
                      <h6 className="m-0  accpetedPay d-flex">
                        {appState.acceptedPayments.length > 0 &&
                          appState?.acceptedPayments.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                {item == "wallets" ? (
                                  <span key={index}>
                                    <img className="img-pro" width="20" src={`/images/quickpay-small.png`} alt={item} />
                                  </span>
                                ) : (
                                  ""
                                )}
                                {item == "apple_pay" ? (
                                  <span key={index}>
                                    <img className="img-pro" width="0" src={`/images/apple-pay.png`} alt={item} />
                                  </span>
                                ) : (
                                  ""
                                )}
                                {item == "knet" ? (
                                  <span key={index}>
                                    <img className="img-pro" width="30" src={`/images/Knet.png`} alt={item} />
                                  </span>
                                ) : (
                                  ""
                                )}
                                {item == "cashable" ? (
                                  <span key={index}>
                                    <img className="img-pro" width="25" src={`/images/simpleCash.png`} alt={item} />
                                  </span>
                                ) : (
                                  ""
                                )}
                                {item == "card" ? (
                                  <span key={index}>
                                    <img className="img-pro" width="20" src={`/images/visa-small.png`} alt={item} />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            );
                          })}
                      </h6>
                    </div>
                  </div>
                )}

                {appState.deliveryMode && appState.deliveryAddsInfo && (
                  <span className={`table-pickup ${   appState.langValue === "ar" ? "mr-auto" : "ml-auto" }`} >
                    <p className="m-0 table-pickup-heading pt-0">
                      <span>
                        <DeliveryDiningIcon />
                      </span>
                      <span className="mx-2"> {t("Delivery")} </span>
                    </p>
                    <p className="m-0  table-picku-no d-flex align-items-center">
                      <span>
                        {appState.deliveryAddsInfo?.city_name
                          ? get_lang(
                              appState.deliveryAddsInfo?.city_name,
                              appState.langValue
                            )
                          : `City`}
                      </span>
                      <span
                        className={` px-1 ${
                          appState.langValue === "ar"
                            ? "text-right familyGraphikArabic"
                            : "text-left familyPoppins300"
                        }`}
                      >
                        {appState.deliveryAddsInfo?.area_name
                          ? ` >  ${get_lang(
                              appState.deliveryAddsInfo?.area_name,
                              appState.langValue
                            )}`
                          : ` >  Area`}
                      </span>
                      <span>
                        <IconButton
                          onClick={() =>
                            appDispatch({
                              type: "setDeliveryAddsPopup",
                              deliveryAddsPopup: true,
                            })
                          }
                        >
                          <Edit />
                        </IconButton>
                      </span>
                    </p>
                  </span>
                )}

                {!appState.deliveryMode && (
                  <div className="mx-3">
                    {appState.qrTable ? (
                      isLoading ? (
                        <Skeleton height={70} />
                      ) : (
                        <>
                          {table && (
                            <span>
                              <p className="m-0 table-pickup-heading py-2">
                                {t("Forms.tableNo")}
                              </p>
                              <p className="m-0  table-picku-no d-flex">
                                {table}
                              </p>
                            </span>
                          )}
                        </>
                      )
                    ) : (
                      ""
                    )}

                    {appState.qrPickup ? (
                      isLoading ? (
                        <Skeleton height={70} />
                      ) : (
                        <>
                          {pickup && (
                            <span>
                              <p className="m-0 table-pickup-heading py-2">
                                Pickup
                              </p>
                              <p className="m-0  table-pickup-no d-flex ">
                                {get_lang(pickup, appState.langValue)}
                              </p>
                            </span>
                          )}
                        </>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withTranslation()(StoreInfoCard);
